import * as React from "react";
const SvgFiRrLasso = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lasso_svg__a)">
      <path
        fill="#062147"
        d="M13 0C6.935 0 2 4.037 2 9a7.54 7.54 0 0 0 .685 3.107 2.94 2.94 0 0 0-.435 3.072A6.98 6.98 0 0 0 0 20a3.89 3.89 0 0 0 4 4 1 1 0 1 0 .008-2A1.886 1.886 0 0 1 2 20a5.04 5.04 0 0 1 1.683-3.426c1.112.328 2.27.475 3.43.435.3 0 .577-.007.843-.016A13.05 13.05 0 0 0 13 18c6.065 0 11-4.037 11-9s-4.935-9-11-9M4.29 14.688a.987.987 0 0 1 0-1.4.985.985 0 0 1 1.4 0A8.4 8.4 0 0 1 6.737 15a7.5 7.5 0 0 1-2.447-.312M13 16c-1.335 0-2.658-.242-3.907-.712A14.5 14.5 0 0 0 7.1 11.876a3.04 3.04 0 0 0-2.691-.795A5.5 5.5 0 0 1 3.999 9c0-3.859 4.038-7 9-7 4.964 0 9 3.141 9 7s-4.036 7-9 7"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lasso_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLasso;
